<template>
  <v-container>
    <div>
      <div v-if="this.GET_STATEIS == 'CUS'">
        <div class="d-flex flex-column mb-6" flat tile>
          <div
            class="d-flex justify-space-around"
            v-for="f in DATA_CUS.length"
            :key="f"
          >
            <div
              v-for="n in DATA_CUS[f - 1]"
              :key="n.index"
              class="ma-3 pa-2"
              style="width: 250px"
              outlined
              tile
            >
              <!-- {{n}} -->
              <div v-if="n.CUSTOMER_NAME">
      
                <div class="d-flex justify-center">
                  {{ n.index }}
                  <qrcode-vue
                    :value="setString(n.NEWCUSTOMER_ID)"
                    :size="100"
                    level="H"
                  ></qrcode-vue>
                </div>
                <div class="d-flex justify-center">
                  <p>{{ n.CUSTOMER_NAME }}</p>
                </div>
              </div>
              <div v-else>
            
                <div class="d-flex justify-center">
                  {{ n.index }}
                  <qrcode-vue
                    :value="setString(n.CUS_ID)"
                    :size="100"
                    level="H"
                  ></qrcode-vue>
                </div>
                <div class="d-flex justify-center">
                  <p>{{ n.CUS_NAME }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="this.GET_STATEIS == 'CAR'">
        <div class="d-flex flex-column mb-6" flat tile>
          <div
            class="d-flex justify-space-around"
            v-for="f in DATA_CAR.length"
            :key="f"
          >
            <div
              v-for="n in DATA_CAR[f - 1]"
              :key="n.index"
              class="ma-3 pa-2"
              style="width: 250px"
              outlined
              tile
            >
              <div class="d-flex justify-center">
                {{ n.index }}
                <qrcode-vue
                  :value="setString(n.CAR_ID)"
                  :size="100"
                  level="H"
                ></qrcode-vue>
              </div>
              <div class="d-flex justify-center">
                <p>{{ n.CAR_NUMBER }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="this.GET_STATEIS == 'PERSON'">
        <div class="d-flex flex-column mb-6" flat tile>
          <div
            class="d-flex justify-space-around"
            v-for="f in DATA_PERSON.length"
            :key="f"
          >
            <div
              v-for="n in DATA_PERSON[f - 1]"
              :key="n.index"
              class="ma-3 pa-2"
              style="width: 250px"
              outlined
              tile
            >
              <div class="d-flex justify-center">
                {{ n.index }}
                <qrcode-vue
                  type="number"
                  :value="setString(n.PERSONNEL_CID)"
                  :size="100"
                  level="H"
                ></qrcode-vue>
              </div>
              <div class="d-flex justify-center">
                <p>{{ n.PERSONNEL_NAME }} {{ n.PERSONNEL_LASTNAME }}</p>
              </div>
              <div class="d-flex justify-center">
                <p>{{ n.PERSONNEL_POSITION }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      GET_STATEIS: "Qrcode/GET_STATEIS",
      GET_CUS: "Qrcode/GET_CUS",
      GET_CAR: "Qrcode/GET_CAR",
      GET_PERSON: "Qrcode/GET_PERSON",
    }),
    DATA_CUS: {
      get() {
        return this.GET_CUS;
      },
    },
    DATA_PERSON: {
      get() {
        return this.GET_PERSON;
      },
    },
    DATA_CAR: {
      get() {
        return this.GET_CAR;
      },
    },
  },
  created() {
    // this.DATA_CUS = this.GET_CUS;
    // console.log(this.DATA_CUS);
    // this.DATA_PERSON = this.GET_PERSON;
    // this.DATA_CAR = this.GET_CAR;
    // console.log(this.GET_CUS);
  },
  methods: {
    setString(data) {
      // console.log(data);
      return String(data);
    },
  },
};
</script>
